module.exports = __webpack_public_path__ + "img/eye-table.40503f2e.svg";